var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-row"},_vm._l((_vm.content),function(c,index){return _c('div',_vm._l((c.content),function(block,i){return _c(block.template,_vm._b({key:'block-' + c + '-' + i,tag:"component"},'component',block,false))}),1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }